module.exports = __webpack_public_path__ + "img/pentagon-half.a8426a78.svg";